import { render, staticRenderFns } from "./InstantSound.vue?vue&type=template&id=2daf86e0&scoped=true&"
import script from "./InstantSound.vue?vue&type=script&lang=js&"
export * from "./InstantSound.vue?vue&type=script&lang=js&"
import style0 from "./InstantSound.vue?vue&type=style&index=0&id=2daf86e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daf86e0",
  null
  
)

export default component.exports